import React, { useState } from 'react';
import Styled, { createGlobalStyle } from 'styled-components';
import { Radio, Modal } from 'antd';
import {
    BookOutlined,
    FilePdfOutlined,
    CloseOutlined,
} from '@ant-design/icons';
import CatalogueSlider from './CatalogueSlider';
import CataloguePdfViewer from './CataloguePdfViewer';

const FooterShowcaseSection = Styled.section`
    margin-bottom: 24px;
    text-align: left;

    /* Top Comparison Header Bar */
    .client-comparison-header {
        background: linear-gradient(135deg, #091a32 0%, #1e293b 100%);
        border: 1px solid #334155;
        border-radius: 10px;
        padding: 12px 18px;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        flex-wrap: wrap;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);

        .header-title-block {
            display: flex;
            align-items: center;
            gap: 10px;

            .badge {
                background: linear-gradient(135deg, #F58826 0%, #e06a09 100%);
                color: #ffffff;
                font-size: 11px;
                font-weight: 700;
                padding: 3px 8px;
                border-radius: 4px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
            }

            h2 {
                margin: 0;
                color: #ffffff;
                font-size: 16px;
                font-weight: 700;
                line-height: 1.2;
            }

            p {
                margin: 2px 0 0 0;
                color: #94a3b8;
                font-size: 12px;
            }
        }

        .comparison-switcher {
            .ant-radio-group {
                display: flex;
                background: #0f172a;
                padding: 3px;
                border-radius: 8px;
                border: 1px solid #334155;

                .ant-radio-button-wrapper {
                    background: transparent;
                    border: none !important;
                    color: #94a3b8;
                    font-size: 12px;
                    height: 30px;
                    line-height: 28px;
                    border-radius: 6px;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    transition: all 0.2s ease;

                    &::before {
                        display: none !important;
                    }

                    &:hover {
                        color: #ffffff;
                    }

                    &.ant-radio-button-wrapper-checked {
                        background: #F58826;
                        color: #ffffff;
                        font-weight: 600;
                        box-shadow: 0 2px 8px rgba(245, 136, 38, 0.4);
                    }
                }
            }
        }
    }
`;

/* Styled container inside Modal */
const ModalBodyWrapper = Styled.div`
    background: #0f172a;
    border-radius: 12px;
    overflow: hidden;

    .modal-top-control-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 14px;
        background: #1e293b;
        border-bottom: 1px solid #334155;
        gap: 10px;
        flex-wrap: wrap;

        .modal-title-left {
            display: flex;
            align-items: center;
            gap: 8px;

            h3 {
                margin: 0;
                color: #ffffff;
                font-size: 13px;
                font-weight: 700;
            }

            .badge {
                background: #F58826;
                color: #ffffff;
                font-size: 10px;
                font-weight: 700;
                padding: 1px 6px;
                border-radius: 4px;
            }
        }

        .modal-switcher-center {
            .ant-radio-group {
                display: flex;
                background: #0f172a;
                padding: 2px;
                border-radius: 6px;
                border: 1px solid #334155;

                .ant-radio-button-wrapper {
                    background: transparent;
                    border: none !important;
                    color: #94a3b8;
                    font-size: 11px;
                    height: 26px;
                    line-height: 24px;
                    border-radius: 4px;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;

                    &::before { display: none !important; }

                    &.ant-radio-button-wrapper-checked {
                        background: #F58826;
                        color: #ffffff;
                        font-weight: 600;
                    }
                }
            }
        }

        .btn-close-modal {
            background: #ef4444;
            border: none;
            color: #ffffff;
            width: 26px;
            height: 26px;
            padding: 0;
            border-radius: 6px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 12px;

            &:hover {
                background: #dc2626;
                color: #ffffff;
            }
        }
    }

    .modal-content-area {
        padding: 0;

        > div {
            border: none !important;
            border-radius: 0 !important;
            box-shadow: none !important;
        }
    }
`;

/* Global style to completely eliminate Ant Design Modal default padding */
const CatalogueModalGlobalStyle = createGlobalStyle`
    .catalogue-zero-padding-modal {
        padding: 0 !important;

        .ant-modal-content {
            padding: 0 !important;
            overflow: hidden !important;
            border-radius: 12px !important;
            background: #0f172a !important;
            box-shadow: 0 25px 60px rgba(0, 0, 0, 0.7) !important;
        }

        .ant-modal-body {
            padding: 0 !important;
            margin: 0 !important;
        }
    }
`;

/* Floating action button pinned to bottom corner */
/* const FloatingCatalogueTrigger = Styled.button`
    position: fixed;
    bottom: 24px;
    ${({ $position }) => ($position === 'left' ? 'left: 24px;' : 'right: 24px;')};
    z-index: 998;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px 8px 10px;
    background: linear-gradient(135deg, #091a32 0%, #1e293b 100%);
    border: 1px solid rgba(245, 136, 38, 0.5);
    border-radius: 50px;
    box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.5), 0 4px 14px rgba(245, 136, 38, 0.3);
    color: #ffffff;
    cursor: pointer;
    outline: none;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    backdrop-filter: blur(8px);
    user-select: none;

    &:hover {
        transform: translateY(-3px) scale(1.02);
        border-color: #F58826;
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.6), 0 6px 18px rgba(245, 136, 38, 0.45);
        background: linear-gradient(135deg, #0d2342 0%, #223046 100%);
    }

    &:active {
        transform: translateY(-1px) scale(0.99);
    }

    .fab-icon-wrap {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: linear-gradient(135deg, #F58826 0%, #ea580c 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 16px;
        box-shadow: 0 2px 8px rgba(245, 136, 38, 0.5);
        flex-shrink: 0;
    }

    .fab-text-block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        line-height: 1.2;

        .fab-label {
            font-size: 13px;
            font-weight: 700;
            color: #ffffff;
            letter-spacing: 0.2px;
            white-space: nowrap;
        }

        .fab-sub {
            font-size: 10px;
            color: #94a3b8;
            display: flex;
            align-items: center;
            gap: 4px;
            margin-top: 2px;
            white-space: nowrap;

            .pulse-dot {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #10b981;
                display: inline-block;
                animation: fabPulse 2s infinite;
            }
        }
    }

    .fab-pages-chip {
        background: rgba(245, 136, 38, 0.15);
        border: 1px solid rgba(245, 136, 38, 0.35);
        color: #F58826;
        font-size: 11px;
        font-weight: 700;
        padding: 3px 8px;
        border-radius: 12px;
        white-space: nowrap;
        margin-left: 2px;
    }

    @keyframes fabPulse {
        0%, 100% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.4); opacity: 0.6; }
    }

    @media (max-width: 640px) {
        bottom: 16px;
        ${({ $position }) => ($position === 'left' ? 'left: 16px;' : 'right: 16px;')};
        padding: 6px;
        border-radius: 50%;

        .fab-text-block,
        .fab-pages-chip {
            display: none;
        }

        .fab-icon-wrap {
            width: 40px;
            height: 40px;
            font-size: 18px;
        }
    }
`; */
export default function CatalogueFooter() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalViewSelection, setModalViewSelection] = useState('slider');

    // const handleOpenModal = () => {
    //     setModalViewSelection('slider');
    //     setIsModalOpen(true);
    // };

    return (
        <>
            <FooterShowcaseSection aria-label="Unique Products Catalogue">
                <CatalogueSlider />
            </FooterShowcaseSection>

            {/* Floating Action Button temporarily hidden.
            <Tooltip
                title="Click to view Unique Products Catalogue in Modal (22 Pages)"
                placement={floatingPosition === 'left' ? 'topRight' : 'topLeft'}
            >
                <FloatingCatalogueTrigger
                    $position={floatingPosition}
                    onClick={handleOpenModal}
                    aria-label="Open Unique Products Catalogue in Modal"
                    type="button"
                >
                    <div className="fab-icon-wrap">
                        <BookOutlined />
                    </div>
                    <div className="fab-text-block">
                        <span className="fab-label">Catalogue</span>
                        <span className="fab-sub">
                            <span className="pulse-dot" /> 22 Pages
                        </span>
                    </div>
                    <span className="fab-pages-chip">PDF</span>
                </FloatingCatalogueTrigger>
            </Tooltip>
            */}

            {/* Pop-up Modal Reader (Triggered by the floating corner button) */}
            <CatalogueModalGlobalStyle />
            <Modal
                className="catalogue-zero-padding-modal"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={1260}
                centered
                destroyOnClose
                closable={false}
                styles={{
                    content: { padding: 0, overflow: 'hidden', borderRadius: 12, background: '#0f172a' },
                    body: { padding: 0 }
                }}
            >
                <ModalBodyWrapper>
                    {/* Top control bar inside modal */}
                    <div className="modal-top-control-bar">
                        <div className="modal-title-left">
                            <span className="badge">Catalogue</span>
                            <h3>Unique Products</h3>
                        </div>

                        {/* Switcher inside Modal */}
                        <div className="modal-switcher-center">
                            <Radio.Group
                                value={modalViewSelection}
                                onChange={(e) => setModalViewSelection(e.target.value)}
                                buttonStyle="solid"
                            >
                                <Radio.Button value="slider">
                                    <BookOutlined /> Carousel
                                </Radio.Button>
                                <Radio.Button value="pdf">
                                    <FilePdfOutlined /> PDF
                                </Radio.Button>
                            </Radio.Group>
                        </div>

                        {/* Close Modal Button */}
                        <button
                            className="btn-close-modal"
                            onClick={() => setIsModalOpen(false)}
                            title="Close Modal (Esc)"
                        >
                            <CloseOutlined />
                        </button>
                    </div>

                    {/* Modal Content */}
                    <div className="modal-content-area">
                        {modalViewSelection === 'slider' ? (
                            <CatalogueSlider />
                        ) : (
                            <CataloguePdfViewer />
                        )}
                    </div>
                </ModalBodyWrapper>
            </Modal>
        </>
    );
}
